/**
 * ESM shim for react-player.
 *
 * Vite 8 / Rollup changed CJS→ESM interop: it no longer automatically unwraps
 * the pattern `module.exports = { __esModule: true, default: Class }` used by react-player.
 * Without this shim, the default import would return the whole object instead of the class.
 *
 * The alias in vite.config redirects `react-player` here; this shim imports from
 * the subpath `react-player/lib/index.js` (which does not match the alias) and manually
 * unwraps the `.default`.
 */

// @ts-ignore — we import the CJS subpath directly to avoid the alias
import _cjsMod from 'react-player/lib/index.js';

// The CJS module exports { __esModule: true, default: ReactPlayerClass }.
// Extract the real default value.
const ReactPlayer = ((_cjsMod as any).default ?? _cjsMod) as typeof import('react-player').default;

export default ReactPlayer;
